<template>
        <div class="warp">
         <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'角色权限管理',goback:true},{name:'角色详情'}]" :title="'角色详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="基础信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">角色名称：</div>
                        <div class="content">{{info.roleName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">描述：</div>
                        <div class="content">{{info.remarks}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">创建人：</div>
                        <div class="content">{{info.createName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">创建时间：</div>
                        <div class="content">{{info.createTime}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                        <div class="name">更新人：</div>
                        <div class="content">{{info.modifyUserName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{info.updateTime}}</div>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
             
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            info:{
                roleName: void 0
            }
        }
    },
    methods:{
        
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosz.get('backstage/sysRole/view/'+this.id)
          if (code == 200) {            
              this.info = data;
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){        
        this.id=this.$route.params.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height: 100%;
  overflow: hidden;
}
.box{
    // margin-top: 20px;
    height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>